import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PhysicalProduct } from '../../../common/model/dto/physical-product/physical-product';
import { useListNavigationState } from '../../../hooks/use-list-navigation-state';
import { usePhysicalProductListColumns } from '../../../hooks/use-physical-product-list-columns';
import OvRecordList from './OvRecordList';

interface OvPhysicalProductListProps {
  physicalProducts: PhysicalProduct[];
}

const OvPhysicalProductList: FC<OvPhysicalProductListProps> = ({
  physicalProducts,
}) => {
  const { t } = useTranslation();
  const getNavigationState = useListNavigationState();
  const columns = usePhysicalProductListColumns(getNavigationState);

  return (
    <OvRecordList
      label={t('app.subPages.menu.physicalProducts')}
      records={physicalProducts}
      columns={columns}
      getKey={(record) => record.id}
      getDetailsPath={(record) => `/physical-products/${record.id}`}
      getNavigationState={getNavigationState}
    />
  );
};

export default OvPhysicalProductList;
